import React from 'react';

const PALETTE = {
  green: { bg: '#DCFCE7', fg: '#15803D' },
  amber: { bg: '#FEF3C7', fg: '#B45309' },
  red:   { bg: '#FEE2E2', fg: '#B91C1C' },
  gray:  { bg: '#E2E8F0', fg: '#475569' },
};

export default function TrustScoreBadge({ score, label, isNew }) {
  if (score == null) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium" style={{ background: PALETTE.gray.bg, color: PALETTE.gray.fg }}>
        —
      </span>
    );
  }
  let p;
  if (score > 70) p = PALETTE.green;
  else if (score >= 40) p = PALETTE.amber;
  else p = PALETTE.red;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-semibold tabular-nums"
      style={{ background: p.bg, color: p.fg }}
      data-testid="trust-score-badge"
      title={`Vertrauen / Trust: ${score}%`}
    >
      <span aria-hidden="true" className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: p.fg }} />
      {score}%
      {isNew && label ? <span className="font-normal opacity-80 ml-1">· {label}</span> : null}
    </span>
  );
}
